/* angular:styles/component:css;f90c9d659cacd4a5c071b86a3f1415ae87448304981c4265b9ae3e03dbc1384b;/Users/stevennaimark/devtoil/Ziptility/Bivvy/src/app/notifications/notification-list.component.ts */
:host {
  height: 100%;
  overflow: auto;
}
/*# sourceMappingURL=notification-list.component.css.map */
